document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.jdg-site-header');
    const openClass = 'jdg-site-header--menu-open';
    const menuToggle = document.querySelector('.jdg-btn--menu');
    const closeNav = document.querySelector('.jdg-btn--close-nav');
    const closeSearch = document.querySelector('.jdg-btn--close-search');
    const searchToggle = document.querySelector('.jdg-btn--search');
    const searchContainer = document.querySelector('.jdg-search-form-container');
    const navContainer = document.querySelector('.jdg-nav-container--secondary');
    const mainNav = document.querySelector('.jdg-site-nav-container');
    const searchClass = 'jdg-search--open';

    let vw = window.innerWidth;

    const trapFocus = element => {
        const focusableEls = element.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="submit"]:not([disabled]), input[type="search"]:not([disabled])'
        );
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const KEYCODE_TAB = 9;

        element.addEventListener('keydown', function (e) {
            const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                /* shift + tab */ if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } /* tab */ else if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        });
    };

    if (menuToggle) {
        menuToggle.addEventListener('click', function () {
            header.classList.add(openClass);
            trapFocus(header);
        });

        closeNav.addEventListener('click', function () {
            header.classList.remove(openClass);
        });
    }

    if (searchToggle) {
        searchToggle.addEventListener('click', () => {
            if (searchContainer.classList.contains(searchClass)) {
                searchToggle.classList.remove(searchClass);
                searchContainer.classList.remove(searchClass);
                closeSearch.classList.remove(searchClass);
            } else {
                searchToggle.classList.add(searchClass);
                searchContainer.classList.add(searchClass);
                closeSearch.classList.add(searchClass);
            }
        });

        closeSearch.addEventListener('click', function () {
            searchToggle.classList.remove(searchClass);
            searchContainer.classList.remove(searchClass);
            closeSearch.classList.remove(searchClass);
        });
    }

    if (navContainer) {
        const searchLocation = () => {
            if (vw >= 1034) {
                navContainer.append(searchContainer);
            } else {
                mainNav.prepend(searchContainer);
            }
        };

        searchLocation();

        window.addEventListener('resize', () => {
            vw = window.innerWidth;

            searchLocation();
        });
    }
});
